import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import Setup from "@/pages/Setup";
import CalendarPage from "@/pages/CalendarPage";
import AvailabilityPage from "@/pages/AvailabilityPage";
import AdminPage from "@/pages/AdminPage";

function FullLoader() {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <Loader2 className="h-7 w-7 animate-spin text-primary" />
    </div>
  );
}

function Gate({ children, adminOnly }) {
  const { user, needsSetup } = useAuth();
  if (user === null || needsSetup === null) return <FullLoader />;
  if (needsSetup) return <Navigate to="/setup" replace />;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function PublicRoute({ children, type }) {
  const { user, needsSetup } = useAuth();
  if (user === null || needsSetup === null) return <FullLoader />;
  if (needsSetup && type !== "setup") return <Navigate to="/setup" replace />;
  if (!needsSetup && type === "setup") return <Navigate to="/login" replace />;
  if (user && type === "login") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/setup" element={<PublicRoute type="setup"><Setup /></PublicRoute>} />
            <Route path="/login" element={<PublicRoute type="login"><Login /></PublicRoute>} />
            <Route path="/" element={<Gate><CalendarPage /></Gate>} />
            <Route path="/disponibilites" element={<Gate><AvailabilityPage /></Gate>} />
            <Route path="/admin" element={<Gate adminOnly><AdminPage /></Gate>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
